<template lang="pug">
div
  .md-headline Content from playlist

  // Playlist
  playlist-selector#playlist-selector(
    v-show='source.type === "playlist"',
    v-model='source.playlist',
    :justPublicStatus='true',
    :showRequiredError='formSubmitted && validations.playlist.$invalid'
  )
  // Non playlist data
  md-layout.additional-settings(md-column, v-if='source.type && source.type !== "playlist"')
    .md-subheading Source Settings
    md-layout(:md-gutter='16')
      // Playlist length
      md-layout(md-flex='50')
        md-input-container
          label Playlist Length
          md-select(v-model='source.params.length', @selected='getVideosInDistribution')
            md-option(:value='1') 1
            md-option(:value='5') 5
            md-option(:value='10') 10
            md-option(:value='15') 15
            md-option(:value='20') 20
            md-option(:value='25') 25
            md-option(:value='30') 30
            md-option(:value='40') 40
            md-option(:value='50') 50
            md-option(:value='100') 100
            md-option(:value='500') 500
            md-option(:value='1000') 1000
      // Playlist Sort
      md-layout(md-flex='50')
        md-input-container
          label Playlist Sort
          md-select(v-model='source.params.sort', @selected='getVideosInDistribution')
            md-option(:value='{ by: "lastUpdated", order: "desc" }') Newest
            md-option(:value='{ by: "lastUpdated", order: "asc" }') Oldest
    // Blocking keywords
    md-chips(
      v-model='source.params.keywordsBlocking',
      :md-max='10',
      md-input-placeholder='Keywords Blocking...',
      @change='getVideosInDistribution'
    )
      template(slot-scope='chip')
        span {{ chip.value }}
  // Videos in this distribution
  loader(:loading='loadingVideos', :size='40')
    distribution-arranged-list.video-list(
      :videos='videosInDistribution',
      :containsInvalidItems='containsInvalidItems',
      label='Videos in this distribution',
      :allow-delete='source.type === "playlist"',
      v-show='source.playlist || source.network || source.channel',
      :deletingItem='deletingItem',
      @removeItem='onItemRemoved',
      @customData='onSetCustomData'
    )
  md-layout(v-show='source.playlist || source.network || source.channel',)
    md-button.md-button(@click="resetSort") Reset Sort
</template>

<script>
import { mapState } from 'vuex';
import PlaylistSelector from '../../playlist/PlaylistSelector';
import PlaylistContentTable from '../../playlist/PlaylistContentTable';
import GeneralNetworkSelector from '../../network/GeneralNetworkSelector';
import GeneralChannelSelector from '../../channel/GeneralChannelSelector';
import playlistService from '../../../services/playlistService';
import mediaItemService from '../../../services/mediaItemService';
import DistributionArrangedList from '../DistributionArrangedList';
import Loader from '../../Loader';
import networkService from '../../../services/networkService';
import channelService from '../../../services/channelService';
export default {
  components: {
    Loader,
    PlaylistSelector,
    PlaylistContentTable,
    GeneralNetworkSelector,
    GeneralChannelSelector,
    DistributionArrangedList
  },
  computed: {
    ...mapState({
      useraccount: state => state.user.useraccount,
      siteuser: state => state.user.siteuser
    }),
  },
  props: {
    source: {
      type: Object,
      required: true
    },
    formSubmitted: {
      type: Boolean,
      required: true
    },
    validations: {
      type: Object,
      required: true
    },
    savePlaylistOrder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPagination: {
        page: 1,
        size: 10
      },
      totalVideos: 0,
      deletingItem: null,
      selectedPlaylist: null,
      videosInDistribution: [],
      loadingVideos: false,
      containsInvalidItems: false,
      currentPage: 0

    };
  },
  methods: {
    showAlertToast(text, icon) {
      this.$swal({
        text: text,
        position: 'bottom-left',
        icon: icon,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      }
      )
    },

    onPageChanged(paginationParams) {
      this.currentPagination = paginationParams;
      this.getVideosInDistribution();
    },
    resetSort() {
      const sourceType = this.source.type;
      const { network, channel } = this.source;
      const resetCustomSort = { customSort: [] }
      if (sourceType === 'network') {
        networkService.get(network)
          .then((response) => {
            const network = response.data.network;
            return networkService.update(network._id, { ...network, ...resetCustomSort });
          })
          .then(() => {
            this.getVideosInDistribution();
          })
          .catch((error) => {
            console.log(error)
          });
      } else if (sourceType === 'channel') {
        channelService.get(channel)
          .then((response) => {
            const channel = response.data.channel;
            return channelService.update(channel._id, { ...channel, ...resetCustomSort });
          })
          .then(() => {
            this.getVideosInDistribution()
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    onSetCustomData(data) {
      if(this.selectedPlaylist){
        this.selectedPlaylist.items = data;
      }
      this.$emit("onSetCustomSort", data);
      this.videosInDistribution = data;
    },
    onItemRemoved(index) {
      const sourceType = this.source.type;
      const { playlist, network, channel } = this.source;
      this.deletingItem = index;
      const mediaitem = this.videosInDistribution[index];
      if (!mediaitem.videoDuration) mediaitem.videoDuration = 0;
      switch (sourceType) {
        case 'playlist': {
          const items = this.videosInDistribution.filter((item, itemIndex) => itemIndex !== index);
          return this.$swal.fire({
            html: `<h4>Are you sure you want to delete this video from this playlist?</h4><h4>This action may impact another distributions</h4> <p><strong>Video name</strong>: ${mediaitem.name}</p>`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete',
            cancelButtonText: 'No',
          }).then(res => {
            if (res.isConfirmed) {
              this.loadingVideos = true;
              playlistService.update(this.selectedPlaylist._id, Object.assign({}, this.selectedPlaylist, { items }))
                .then(() => {
                  this.loadingVideos = false;
                  this.deletingItem = null;
                  this.videosInDistribution.splice(index, 1);
                  this.showAlertToast('Video deleted successfully', 'success');
                })
                .catch(() => {
                  this.showAlertToast('Something wrong!', 'error');
                  this.deletingItem = null;
                });
            }
          })
        }
        case 'network': {
          this.$swal.fire({
            html: `<h4>Are you sure you want to delete this video from this network?</h4><h4>This action may impact another distributions</h4> <p><strong>Video name</strong>: ${mediaitem.name}</p>`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete',
            cancelButtonText: 'No',
          }).then(res => {
            if (res.isConfirmed) {
              this.loadingVideos = true;
              mediaitem.network = null;
              mediaItemService.update(mediaitem._id, mediaitem)
                .then(() => {
                  return networkService.get(network)
                })
                .then(({ data }) => {
                  const { network: networkData } = data;
                  networkData.customSort = networkData.customSort.filter((item) => item !== mediaitem._id);
                  return networkService.update(network, networkData);
                })
                .then(() => {
                  this.getVideosInDistribution();
                  this.loadingVideos = false;
                  this.showAlertToast('Video deleted successfully', 'success');
                })
                .catch((error) => {
                  this.showAlertToast('Something wrong!', 'error');
                  console.log("Error in network update: ", error);
                });
            }
          })
          return;
        }
        case 'channel': {
          mediaitem.channels = mediaitem.channels.filter((chan) => chan !== channel);
          this.$swal.fire({
            html: `<h4>Are you sure you want to delete this video from this channel?</h4><h4>This action may impact another distributions</h4> <p><strong>Video name</strong>: ${mediaitem.name}</p>`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete',
            cancelButtonText: 'No',
          }).then(res => {
            if (res.isConfirmed) {
              this.loadingVideos = true;
              mediaItemService.update(mediaitem._id, mediaitem)
                .then(() => {
                  return channelService.get(channel)
                })
                .then(({ data }) => {
                  const { channel: channelData } = data;
                  channelData.customSort = channelData.customSort.filter((item) => item !== mediaitem._id);
                  return channelService.update(channel, channelData);
                })
                .then(() => {
                  this.getVideosInDistribution();
                  this.loadingVideos = false;
                  this.showAlertToast('Video deleted successfully', 'success');
                })
                .catch((error) => {
                  this.showAlertToast('Something wrong!', 'error');
                  console.log("Error in network update: ", error);
                });
            }
          })
          return;
        }
      }
    },
    onSourceTypeChanged() {
      this.source.playlist = null;
      this.source.network = null;
      this.source.channel = null;
    },
    getVideosInDistribution() {
      if (this.source.type !== 'playlist') {
        this.source.type = 'playlist';
      }
      const sourceType = this.source.type;
      const { playlist, network, channel } = this.source;
      this.loadingVideos = true;

      switch (sourceType) {
        case 'playlist': {

          if(!playlist) {
            this.loadingVideos = false;
            return
          };

          playlistService.get(playlist)
            .then((response) => {
              this.selectedPlaylist = response.data;
              this.videosInDistribution = response.data.items;
              this.containsInvalidItems = this.selectedPlaylist.containsInvalidItems;

              while(this.currentPage+1 < response.data.totalPages){
                this.currentPage++;
                playlistService.get(playlist, {page: this.currentPage})
                  .then((response) => {
                    this.videosInDistribution.push(...response.data.items);
                  })
              }
            })
            .catch((error) => {
              console.error('Error while retrieving the playlist details.', error);
            })
            .then(() => {
              this.loadingVideos = false;
            });
          break;
        }
        default: {
          const params = {
            status: 'public',
            encodingStatus: 'completed',
            offset: this.currentPagination.size * (this.currentPagination.page - 1),
            limit: this.source.params.length,
            sortBy: this.source.params.sort.by,
            sortOrder: this.source.params.sort.order,
            keywordsBlocking: this.source.params.keywordsBlocking.join(';'),
            marketplace: true
          };
          let customSort = [];
          if (sourceType === 'network') {
            Object.assign(params, { network });
            networkService.get(network)
              .then(({ data }) => {
                if (Array.isArray(data.network.customSort)) {
                  customSort = data.network.customSort;
                }
                return mediaItemService.getList(params)
              })
              .then(({ data }) => {
                this.totalVideos = data.total < this.source.params.length ? data.total : this.source.params.length;
                if (customSort.length > 0) {
                  const tempArrayVideos = customSort.map(
                    (videoId) =>
                      data.mediaItems.find((mediaitem) => mediaitem._id === videoId)
                  );
                  this.videosInDistribution = tempArrayVideos.filter(v => v).slice(0, data.mediaItems.length);
                } else {
                  this.videosInDistribution = data.mediaItems;
                }
              })
              .catch((error) => {
                console.error(`Error while retrieving the media items for ${sourceType}`, error);
              })
              .then(() => {
                this.loadingVideos = false;
              });
          } else {
            Object.assign(params, { channel });
            channelService.get(channel)
              .then(({ data }) => {
                if (Array.isArray(data.channel.customSort) && data.channel.customSort.length > 0) {
                  customSort = data.channel.customSort;
                }
                return mediaItemService.getList(params);
              })
              .then(({ data }) => {
                this.totalVideos = data.total < this.source.params.length ? data.total : this.source.params.length;
                if (customSort.length > 0) {
                  const tempArrayVideos = customSort.map(
                    (videoId) =>
                      data.mediaItems.find((mediaitem) => mediaitem._id === videoId)
                  );
                  this.videosInDistribution = tempArrayVideos.filter(v => v).slice(0, data.mediaItems.length);
                } else {
                  this.videosInDistribution = data.mediaItems;
                }
              })
              .catch((error) => {
                console.error(`Error while retrieving the media items for ${sourceType}`, error);
              })
              .then(() => {
                this.loadingVideos = false;
              });
          }


          break;
        }
      }
    }
  },
  mounted() {
    this.getVideosInDistribution();
  },
  watch: {
    savePlaylistOrder() {
      playlistService.update(this.selectedPlaylist._id, this.selectedPlaylist)
    },
    videosInDistribution: {
      handler() {
        if (this.source.type === 'playlist' && this.source.playlist) {
          this.$emit('playlist-items', this.videosInDistribution);
        }
      },
      deep: true,
    },
    'source.playlist': function (newVal) {
      if (newVal) {
        this.getVideosInDistribution();
      }
    },
    'source.network': function (newVal) {
      if (newVal) {
        this.getVideosInDistribution();
      }
    },
    'source.channel': function (newVal) {
      if (newVal) {
        this.getVideosInDistribution();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-wrapper-frame {
  width: 100%;
  padding: 25px;
  margin-bottom: 15px;

  .control-loader {
    margin-top: 25px;
  }

  .additional-settings {
    padding-top: 20px;
  }

  .video-list {
    margin: 20px 0;
  }

  .md-button {
    background-color: #4ea9dd;
    color: rgba(255, 255, 255, .87);
  }
}

.md-table-pagination {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 10px auto;
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/distribution/form-components/ContentForm.vue